import { Clock, Utensils, CheckCircle, Heart } from "lucide-react";

export const CorporateSection = () => {
  const features = [
    {
      icon: Clock,
      title: "Consistent, dependable service",
      description: "On-time delivery, every time"
    },
    {
      icon: Utensils,
      title: "Veg-forward menus with premium non-veg options",
      description: "Something for everyone"
    },
    {
      icon: CheckCircle,
      title: "Clean, labeled, and professional setups",
      description: "Ready to serve"
    },
    {
      icon: Heart,
      title: "Dietary-inclusive and senior-friendly",
      description: "Thoughtful accommodations"
    }
  ];

  return (
    <section
      id="corporate"
      className="py-20 md:py-32 px-6 md:px-12 lg:px-24 bg-white"
      data-testid="corporate-section"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Image */}
          <div className="relative order-2 lg:order-1">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden shadow-xl img-zoom">
              <img
                src="https://images.unsplash.com/photo-1568604003986-c1b9021fbd42?crop=entropy&cs=srgb&fm=jpg&q=85"
                alt="Professional corporate lunch catering setup"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Decorative elements */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-orange-100 rounded-2xl -z-10" />
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-green-50 rounded-full -z-10" />
          </div>

          {/* Right Content */}
          <div className="space-y-8 order-1 lg:order-2">
            <div className="space-y-4">
              <p className="text-sm tracking-widest uppercase font-semibold text-orange-700">
                Professional, yet personal
              </p>
              <h2 className="font-heading text-4xl md:text-5xl font-semibold tracking-tight text-gray-800">
                Corporate Catering, Done Right
              </h2>
            </div>

            <p className="text-lg md:text-xl leading-relaxed text-gray-600">
              Kamaliicious specializes in reliable, high-quality corporate catering designed for modern workplaces. From daily office lunches to executive meetings and large team gatherings, we deliver food that feels comforting yet polished — always on time, beautifully presented, and thoughtfully portioned.
            </p>

            {/* Features */}
            <div className="grid sm:grid-cols-2 gap-6 pt-4">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4 p-4 rounded-xl hover:bg-stone-50 transition-colors duration-300"
                >
                  <div className="w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0">
                    <feature.icon className="w-6 h-6 text-orange-700" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">{feature.title}</h3>
                    <p className="text-sm text-gray-600 mt-1">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Closing line */}
            <div className="pt-6 border-l-4 border-orange-700 pl-6">
              <p className="font-accent text-xl italic text-gray-700">
                "Because feeding teams well is part of building great culture."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CorporateSection;
